module.exports = __webpack_public_path__ + "img/cover.016abb84.jpg";